


import { createApiCall } from 'services'

import { call, fork, takeLatest } from 'redux-saga/effects'

import { ActionCallback } from '../model'
import { ActionType, UploadTagsFileFields } from './types'




export function* uploadTagsFileSaga(): Generator {
  yield takeLatest(ActionType.UPLOAD_CSV_TAG_FILE, function* (action: ActionCallback<UploadTagsFileFields>) {
    const { payload, callback } = action
    try {
      const form = new FormData()
      form.append('file', payload.file)

      const response: { status: number } = yield call(createApiCall, {
        method: 'POST',
        url: `/tags/upload`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: form,
      })

      const { status } = response

      if (callback) {
        callback({
          success: status === 201,
        })
      }
    } catch (error) {
      if (callback) {
        console.log(error)
        callback({
          success: false,
          content: "Couldn't upload file",
        })
      }
    }
  })
}

export default [fork(uploadTagsFileSaga)]
